const Backofficebff: any = import.meta.env.VITE_BACKOFFICEBFF!;

export const GlobaldataCommand: any = {
    DeleteGlobaldataToken: `${Backofficebff}/v1/globaldata/delete-token`,
    AddGlobaldataToken: `${Backofficebff}/v1/globaldata/add-token`,
    UpdateGlobaldataToken: `${Backofficebff}/v1/globaldata/update-token`,
    UpdateSupportedCountry: `${Backofficebff}/v1/globaldata/update-bo-supported-country`,
    CreateSupportedCountry: `${Backofficebff}/v1/globaldata/create-bo-supported-country`,
    DeleteSupportedCountry: `${Backofficebff}/v1/globaldata/delete-bo-supported-country`,
    SortSupportedCountries: `${Backofficebff}/v1/globaldata/update-bo-supported-country-display-order`,
    UpdateSupportedLanguage: `${Backofficebff}/v1/globaldata/update-bo-supported-language`,
    CreateSupportedLanguage: `${Backofficebff}/v1/globaldata/create-bo-supported-language`,
    DeleteSupportedLanguage: `${Backofficebff}/v1/globaldata/delete-bo-supported-language`,
    SortSupportedLanguages: `${Backofficebff}/v1/globaldata/update-bo-supported-language-display-order`,

    GlobaldataDeleteRedisKey: `${Backofficebff}/globaldata-managecache/delete-redis-by-key`,
    GlobaldataBulkDeleteRedisKeys: `${Backofficebff}/globaldata-managecache/bulk-delete-cache`,
    GlobaldataDeleteCache: `${Backofficebff}/globaldata-managecache/delete-cache`,
    UpdateSupportedCurrency: `${Backofficebff}/v1/globaldata/update-country-supported-currency`,
};
